import {Desk, EmployeeRef, INeighbourhood} from "../../../api/Model";
import {EmployeeVisitFigure} from "../../employee-visit-report/EmployeeVisitReportFilter";
import {DeskModel} from "../../desks/DeskModel";
import {calculateNeighbourhoodSharing, NeighbourhoodSharing} from "../../floors/FloorModel";
import {getOrSet} from "../../../util/MapUtil";
import {combineCmp, naturalCmpOptions, numberCmp, stringCmp} from "../../../util/SortUtil";

export type UnderutilizedAssignedDesk = {
    desk: Desk,
    employee: EmployeeRef,
    utilization: EmployeeVisitFigure,
};

export type NeighbourhoodDeskUtilizationComparison = {
    neighbourhood: INeighbourhood,
    flexUtilization: NeighbourhoodSharing,
    assignedDesks: UnderutilizedAssignedDesk[],
};

export function findNeighbourhoodsWithUnderutilizedAssignedDesks(
    deskModel: DeskModel,
    desks: Desk[],
): NeighbourhoodDeskUtilizationComparison[] {
    const flexUtilizationByNeighbourhood = calculateNeighbourhoodSharing(desks, deskModel);
    const comparisons = new Map<INeighbourhood['key'], NeighbourhoodDeskUtilizationComparison>();

    desks.forEach(desk => {
        const assignedDesk = deskModel.employeeVisitStats(desk);
        const neighbourhood = deskModel.neighbourhood(desk);
        if (!assignedDesk || !neighbourhood || !Number.isFinite(assignedDesk.stats.percent)) return;

        const flexUtilization = flexUtilizationByNeighbourhood.get(neighbourhood.key);
        if (!flexUtilization || !Number.isFinite(flexUtilization.percent)) return;
        if (assignedDesk.stats.percent >= flexUtilization.percent) return;

        getOrSet(comparisons, neighbourhood.key, () => ({
            neighbourhood,
            flexUtilization,
            assignedDesks: [],
        })).assignedDesks.push({
            desk,
            employee: assignedDesk.employee,
            utilization: assignedDesk.stats,
        });
    });

    comparisons.forEach(comparison => comparison.assignedDesks.sort(combineCmp(
        numberCmp(({utilization}) => utilization.percent),
        stringCmp(({desk}) => desk.name, false, naturalCmpOptions),
    )));

    return [...comparisons.values()].sort(combineCmp(
        numberCmp(({flexUtilization}) => flexUtilization.percent, true),
        stringCmp(({neighbourhood}) => neighbourhood.name),
    ));
}
